var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6811 10.4802C20.6811 4.8206 16.0993 0.227295 10.4538 0.227295C4.80838 0.227295 0.226562 4.8206 0.226562 10.4802C0.226562 15.4426 3.74474 19.5745 8.40838 20.528V13.5561H6.36293V10.4802H8.40838V7.91697C8.40838 5.93816 10.0141 4.32846 11.9879 4.32846H14.5447V7.40433H12.4993C11.9368 7.40433 11.4766 7.86571 11.4766 8.42962V10.4802H14.5447V13.5561H11.4766V20.6818C16.6413 20.1692 20.6811 15.8015 20.6811 10.4802Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.6fce283964524e333d8862a1e8f95c3c.svg";
export { ForwardRef as ReactComponent };